import React from 'react';
import TruncatedText from 'src/shared/components/ui/TruncatedText';
import RiskScoreCell, { type RiskScoreDirection } from 'src/shared/components/risk-score-cell/RiskScoreCell';

export type RiskDriverItemProps = {
    name: string;
    score: number | null;
    description: string | null;
    direction?: RiskScoreDirection;
    isLoading?: boolean;
};

const RiskDriverItem = ({ name, score, description, direction = 'higher-worse', isLoading = false }: RiskDriverItemProps) => {
    if (isLoading) {
        return (
            <div data-testid='risk-driver-skeleton' className='flex flex-col gap-1 animate-pulse'>
                <div className='h-4 bg-grey-20 rounded w-3/4' />
                <div className='h-3 bg-grey-20 rounded w-full' />
                <div className='h-2 bg-grey-20 rounded w-full' />
            </div>
        );
    }

    return (
        <div className='flex flex-col gap-1'>
            <div className='flex items-center justify-between gap-2'>
                <TruncatedText text={name} className='flex-1 text-sm text-black' />
                <span className='text-sm text-grey-100 tabular-nums shrink-0'>{score !== null ? score.toFixed(2) : '—'}</span>
            </div>

            {description !== null && (
                <TruncatedText text={description} lines={2} data-testid='risk-driver-description' className='text-xs text-grey-80' />
            )}

            <RiskScoreCell value={score} direction={direction} layout='bar-only' />
        </div>
    );
};

export default RiskDriverItem;
